"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var ParBrandsOffersListCtl = /** @class */ (function (_super) {
    __extends(ParBrandsOffersListCtl, _super);
    function ParBrandsOffersListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_offer_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.offer_type_title; });
        _this.dk_offer_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.offer_type_code; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_locales_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.locales_count; });
        _this.dk_cms_image_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_image_url; });
        _this.dk_formula_partner_profit = UIUtils_1.UIUtils.IProp2Str(function (o) { o.formula_partner_profit; });
        _this.dk_formula_brand_profit = UIUtils_1.UIUtils.IProp2Str(function (o) { o.formula_brand_profit; });
        _this.dk_formula_deposit_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.formula_deposit_comission; });
        _this.dk_formula_withdraw_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.formula_withdraw_comission; });
        _this.dk_test_json = UIUtils_1.UIUtils.IProp2Str(function (o) { o.test_json; });
        _this.dk_order_number = UIUtils_1.UIUtils.IProp2Str(function (o) { o.order_number; });
        _this.dk_is_all_country = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_all_country; });
        _this.dk_countries_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.countries_count; });
        _this.dk_is_for_brand_stat = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_for_brand_stat; });
        _this._errDialog = errDialog;
        return _this;
    }
    ParBrandsOffersListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0,
            cdn_baseurl: ""
        };
    };
    ParBrandsOffersListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "brand offer with id [" + id + "] not found !";
    };
    ParBrandsOffersListCtl.prototype.LoadData = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        webAApi_1.ListBrandOffersByBrandsGet.exec({ all_brands: AllBrands, brand_id_list: BrandIdList }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    offer_type_code: resp.list[i].offer_type_code,
                    offer_type_title: resp.list[i].offer_type_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    description: resp.list[i].description,
                    is_deprecated: resp.list[i].is_deprecated,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    locales_count: resp.list[i].locales_count,
                    cms_image_url: resp.list[i].cms_image_url,
                    formula_partner_profit: resp.list[i].formula_partner_profit,
                    formula_brand_profit: resp.list[i].formula_brand_profit,
                    formula_deposit_comission: resp.list[i].formula_deposit_comission,
                    formula_withdraw_comission: resp.list[i].formula_withdraw_comission,
                    test_json: resp.list[i].test_json,
                    order_number: resp.list[i].order_number,
                    is_all_country: resp.list[i].is_all_country,
                    countries_count: resp.list[i].countries_count,
                    is_for_brand_stat: resp.list[i].is_for_brand_stat
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParBrandsOffersListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandOffer.exec({
            data: {
                title: data.title,
                brand_id: data.brand_id,
                offer_type_code: data.offer_type_code,
                description: data.description,
                is_deprecated: data.is_deprecated,
                cms_image_url: data.cms_image_url,
                order_number: data.order_number,
                is_all_country: data.is_all_country,
                formula_partner_profit: data.formula_partner_profit,
                formula_brand_profit: data.formula_brand_profit,
                formula_deposit_comission: data.formula_deposit_comission,
                formula_withdraw_comission: data.formula_withdraw_comission,
                is_for_brand_stat: data.is_for_brand_stat
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                title: data.title,
                offer_type_code: data.offer_type_code,
                offer_type_title: resp.offer_type_title,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                description: data.description,
                is_deprecated: data.is_deprecated,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                locales_count: 0,
                cms_image_url: data.cms_image_url,
                formula_partner_profit: data.formula_partner_profit,
                formula_brand_profit: data.formula_brand_profit,
                formula_deposit_comission: data.formula_deposit_comission,
                formula_withdraw_comission: data.formula_withdraw_comission,
                test_json: resp.test_json,
                order_number: data.order_number,
                is_all_country: data.is_all_country,
                countries_count: 0,
                is_for_brand_stat: data.is_for_brand_stat
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParBrandsOffersListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandOffer.exec({
                data: {
                    brands_partner_offer_id: data.key,
                    title: data.title,
                    description: data.description,
                    is_deprecated: data.is_deprecated,
                    cms_image_url: data.cms_image_url,
                    formula_partner_profit: data.formula_partner_profit,
                    formula_brand_profit: data.formula_brand_profit,
                    order_number: data.order_number,
                    is_all_country: data.is_all_country,
                    formula_deposit_comission: data.formula_deposit_comission,
                    formula_withdraw_comission: data.formula_withdraw_comission,
                    is_for_brand_stat: data.is_for_brand_stat
                }
            }, function (resp) {
                _tmp.description = data.description;
                _tmp.title = data.title;
                _tmp.is_deprecated = data.is_deprecated;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.cms_image_url = data.cms_image_url;
                _tmp.formula_partner_profit = data.formula_partner_profit;
                _tmp.formula_brand_profit = data.formula_brand_profit;
                _tmp.order_number = data.order_number;
                _tmp.is_all_country = data.is_all_country;
                _tmp.is_for_brand_stat = data.is_for_brand_stat;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsOffersListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    ParBrandsOffersListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandOffer.exec({ data: { brand_partner_offer_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsOffersListCtl.prototype.doSetIsDeprecated = function (key, isDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandOfferIsDeprecated.exec({ data: { brands_partner_offer_id: key, is_deprecated: isDeprecated } }, function (resp) {
                _tmp.is_deprecated = isDeprecated;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsOffersListCtl.prototype.doSetOrderNumber = function (key, OrderNumber, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandOfferPriority.exec({
                data: {
                    brand_partner_offer_id: key,
                    order_number: OrderNumber
                }
            }, function (resp) {
                _tmp.order_number = OrderNumber;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsOffersListCtl.prototype.GetDefaultTestData = function (onData) {
        var _this = this;
        webAApi_1.DetailsDefaultOfferFormulaAndTestDataGet.exec({}, function (resp) {
            if (onData) {
                onData(resp.default_partner_profit_formula, resp.default_brand_profit_formula, resp.default_deposit_comission_formula, resp.default_withdraw_comission_formula, UIUtils_1.UIUtils.Base64DecodeU(resp.default_test_json_b64));
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParBrandsOffersListCtl.prototype.DoTestFormula = function (Formula, Test_json, onSuccess, onError) {
        var _this = this;
        webAApi_1.DoTestOfferFormula.exec({
            formula: Formula,
            test_json_b64: UIUtils_1.UIUtils.Base64EncodeU(Test_json)
        }, function (resp) {
            if (resp.is_error) {
                var _err = "";
                for (var i = 0; i < resp.list_errors.length; i++) {
                    _err = "" + _err + resp.list_errors[i];
                }
                onError(_err);
            }
            else {
                if (onSuccess) {
                    onSuccess(resp.result);
                }
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return ParBrandsOffersListCtl;
}(BaseController_1.BaseController));
exports.ParBrandsOffersListCtl = ParBrandsOffersListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_offers_list/ctl/ParBrandsOffersListCtl.ts
// module id = 957
// module chunks = 0